<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-6">
        <label class="ts-text-xs ts-mb-0">{{
          $t('expensePosting.productGroup')
        }}</label>
        <a-select v-model="pro_group_id" :options="productGroups" show-search allowClear option-filter-prop="children"
          class="ts-w-full" placeholder="Select" @change="onChangeProGroup"></a-select>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs ts-mb-0">{{
          $t('expensePosting.product')
        }}</label>
        <a-select v-model="product_id" :options="products" show-search allowClear option-filter-prop="children"
          class="ts-w-full" placeholder="Select" @search="handleSearchProduct" @change="onChangeProduct"
          :loading="product_searching" :disabled="product_searching"></a-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs ts-mb-0">
          {{ $t('expensePosting.imei') }}
        </label>
        <a-select v-model="serial_no" :options="serials" show-search allowClear option-filter-prop="children"
          class="ts-w-full" @search="handleSearchSerial" @change="onChangeSerial" placeholder="Select"
          :loading="product_serial" :disabled="product_serial"></a-select>
      </div>
    </div>

    <fieldset>
      <legend class="text-blue">
        {{ $t('expensePosting.expItem') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('expensePosting.expItem') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="ts-space-y-2">
        <div class="row filter">
          <div class="col-md-6">
            <a-select v-model="exp_cat_id" :options="expenseCategories" show-search allowClear
              option-filter-prop="children" class="ts-w-full" style="height: 30px;"
              placeholder="Filter By Category"></a-select>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <input v-model.trim="search" type="text" :placeholder="$t('expensePosting.searchItem')"
              class="form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 overflow-auto">
            <div class="table-ui-detail" style="min-height: 100px; max-height: 200px">
              <table class="ts-w-full" style="max-height: 200px">
                <thead>
                  <tr>
                    <th width="40%">
                      {{ $t('expensePosting.expCategory') }}
                    </th>
                    <th width="15%">
                      {{ $t('expensePosting.expCode') }}
                    </th>
                    <th width="40%">
                      {{ $t('expensePosting.expItem') }}
                    </th>
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="expenseItems.length == 0">
                    <td colspan="4" class="ts-text-center ts-p-3 ts-space-x-1">
                      <i class="fa fa-folder-open ts-text-gray-200"></i>
                      <label class="ts-text-gray-400">
                        {{ $t('noData') }}
                      </label>
                    </td>
                  </tr>
                  <tr v-else v-for="(item, index) in expenseItems" :value="item.exp_id" :key="index"
                    class="ts-cursor-pointer hover:ts-bg-gray-300">
                    <td class="ts-px-2">
                      {{ item.exp_category }}
                    </td>
                    <td class="ts-px-2">
                      {{ item.exp_code }}
                    </td>
                    <td class="ts-px-2">
                      {{ item.exp_item }}
                    </td>
                    <td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
                      <a href="#" class="ts-text-blue-500" @click.prevent="addItem(item)">
                        <i class="fa fa-plus"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'expItemList',
  props: ['value'],
  data() {
    return {
      showForm: false,
      search: '',
      product_searching: false,
      product_serial: false,
      pro_group_id: null,
      product_id: null,
      serial_no: null,
      exp_cat_id: undefined,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('expense/expensePosting', ['formViewDatas']),
    expenseCategories() {
      if (this.formViewDatas['expenseCategories']) {
        return this.formViewDatas['expenseCategories'].map(el => ({
          value: el.exp_cat_id,
          label: el.exp_cat_code + '|' + el.exp_category
        }))
      }
      return []
    },
    expenseItems() {
      if (this.formViewDatas['expenseItems']) {
        return this.formViewDatas['expenseItems']
          .filter(el =>
            this.exp_cat_id ? el.exp_cat_id == this.exp_cat_id : true
          )
          .filter(
            ei =>
              this.search
                .split(' ')
                .every(s =>
                  ei.exp_code.toLowerCase().includes(s.toLowerCase())
                ) ||
              this.search
                .split(' ')
                .every(s => ei.exp_item.toLowerCase().includes(s.toLowerCase()))
          )
      }
      return []
    },
    productGroups() {
      if (this.formViewDatas['productGroups']) {
        return this.formViewDatas['productGroups'].map(el => ({
          value: el.pro_group_id,
          label:
            el.category_name_en +
            (el.pro_group_name_en ? '|' + el.pro_group_name_en : '')
        }))
      }
      return []
    },
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products'].map(el => ({
          value: el.product_id,
          label:
            el.product_name_en +
            (el.product_name_kh ? '|' + el.product_name_kh : '')
        }))
      }
      return []
    },
    serials() {
      if (this.formViewDatas['serials']) {
        return this.formViewDatas['serials'].map(el => ({
          value: el.serial_no,
          label: el.serial_no + (el.imei ? '|' + el.imei : ''),
          pro_group_id: el.pro_group_id,
          product_id: el.product_id
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('expense/expensePosting', ['getFormViewModel']),
    handleSearchProduct: debounce(async function (value) {
      this.product_searching = true
      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          search_product: value,
          pro_group_id: this.pro_group_id
        }
      })
      this.product_searching = false
    }, 800),
    handleSearchSerial: debounce(async function (value) {
      this.product_serial = true
      await this.getFormViewModel({
        index: 'serials',
        params: {
          fnName: 'serials',
          search_serial: value,
          product_id: this.product_id ? [this.product_id] : undefined
        }
      })
      this.product_serial = false
    }, 800),
    async onChangeProGroup(value) {
      this.product_id = null
      this.serial_no = null
      this.product_searching = true
      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          pro_group_id: this.pro_group_id
        }
      })
      this.product_searching = false
    },
    async onChangeProduct(value) {
      this.serial_no = null
      this.product_serial = true
      await this.getFormViewModel({
        index: 'serials',
        params: {
          fnName: 'serials',
          product_id: [this.product_id]
        }
      })
      this.product_serial = false
    },
    async onChangeSerial(value, option) {
      this.pro_group_id = value ? option.data.props.pro_group_id : null
      this.product_id = value ? option.data.props.product_id : null
      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          product_id: [this.product_id]
        }
      })
    },
    addItem(item) {
      let uom = this.formViewDatas['unitOfMeasures'].find(
        el => el.uom_cat_id == item.uom_cat_id && el.is_default == true
      )
      let currency = this.formViewDatas['currency'].find(
        el => el.is_default == true
      )

      let newItem = {
        exp_detail_id: null,
        exp_id: item.exp_id,
        expense_by: null,
        purpose: null,
        vendor: null,
        product_id: this.product_id,
        serial_no: this.serial_no,
        uom_id: uom.uom_id,
        input_currency_id: currency ? currency.currency_id : null,
        currency_id: currency ? currency.currency_id : null,
        fx_rate: 1,
        fx_rate_ratio: 1,
        quantity: 1,
        input_unit_price: 0,
        unit_price: 0,
        input_total: 0,
        total: 0,
        order: this.model.details.length + 1
      }
      this.model.details.push(newItem)
    },
    removeRow(detail) {
      this.model.planned_maintenance.splice(
        this.model.planned_maintenance.indexOf(detail),
        1
      )
    }
  }
}
</script>
<style scoped>
.form-control {
  height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
  height: 29px;
}
</style>
